<!-- eslint-disable vue/no-mutating-props -->

<script lang="ts" setup>
import BlocklistSetting from './BlocklistSetting.vue'

type EnrichmentFilters = {
  currentPosition: boolean
  jobHistory: boolean
  education: boolean
  companyOverview: boolean
  companyNews: boolean
  companyFunding: boolean
  weather: boolean
  talkingPoints: boolean
  location: boolean
}

const props = defineProps<{
  enrichmentFilters: EnrichmentFilters
}>()

const emit = defineEmits<{
  'update:enrichmentFilters': [value: EnrichmentFilters]
}>()

const filters: Array<{
  name: string
  key: keyof EnrichmentFilters
}> = [
  { name: 'Current Position', key: 'currentPosition' },
  { name: 'Job History', key: 'jobHistory' },
  { name: 'Education', key: 'education' },
  { name: 'Company Overview', key: 'companyOverview' },
  { name: 'Company News', key: 'companyNews' },
  { name: 'Company Funding', key: 'companyFunding' },
  { name: 'Weather', key: 'weather' },
  { name: 'Discussion Points', key: 'talkingPoints' },
  { name: 'Location', key: 'location' }
]

function updateFilter(key: keyof EnrichmentFilters, value: boolean) {
  const updatedFilters = {
    ...props.enrichmentFilters,
    [key]: value
  }
  emit('update:enrichmentFilters', updatedFilters)
}
</script>

<template>
  <div class="myCard q-pa-md">
    <h6 class="text-h6">What Info Do You Want in Your Meeting Prep?</h6>
    <div class="row">
      <q-list v-for="filter in filters" :key="filter.key" class="col-12 col-md-4">
        <q-item tag="label" v-ripple dense>
          <q-item-section side>
            <q-checkbox
              :model-value="enrichmentFilters[filter.key]"
              @update:model-value="(value) => updateFilter(filter.key, value)"
            />
          </q-item-section>

          <q-item-section>
            <q-item-label>{{ filter.name }}</q-item-label>
          </q-item-section>
        </q-item>
      </q-list>
    </div>
    <BlocklistSetting />
  </div>
</template>
